import PropTypes from 'prop-types';

import { Head } from 'humanity/components/head';
import { pageSettingsType } from 'types';
import Layout from 'layouts';
import {
  LearningCenterPage,
  learningCenterPageType,
} from 'humanity/pages/learningCenterPage';
import { getLearningCenterPageSSR } from 'humanity/pages/learningCenterPage/learningCenterPage.query';
import { PARENT_SLUGS } from 'utils/learningCenterConstants';

const LearningCenterCategoryPage = ({
  parentSlug,
  preview = false,
  pageSettings,
  pageContent,
  page,
}) => (
  <Layout
    type="learningCenter"
    layout={pageSettings.layout}
    notes={pageSettings.notes?.itemsCollection?.items}
    disclosures={pageSettings.disclosures?.itemsCollection?.items}
  >
    <Head
      title={pageSettings.seoMetadata?.title}
      description={pageSettings.seoMetadata?.description}
      url={`${process.env.NEXT_PUBLIC_HI_BASE_URL}${pageSettings?.seoMetadata?.canonicalUrl}${page ? `?page=${page}` : ''}`}
      noIndex={pageSettings.seoMetadata?.noIndex}
    />
    <LearningCenterPage
      pageContent={pageContent}
      parentSlug={parentSlug}
      preview={preview}
    />
  </Layout>
);

LearningCenterCategoryPage.propTypes = {
  pageSettings: pageSettingsType.isRequired,
  pageContent: learningCenterPageType.isRequired,
  parentSlug: PropTypes.string.isRequired,
  preview: PropTypes.bool.isRequired,
  page: PropTypes.string.isRequired,
};

export default LearningCenterCategoryPage;

export const getServerSideProps = getLearningCenterPageSSR(
  'learn',
  PARENT_SLUGS.CATEGORIES
);
